/*
 * Created by liumingquan on 2018/6/7.
 * http://test-a.cd.pangu16.com/content-server/swagger-ui.html
 */
const devConf = {
  ssoLoginUrl: 'http://dev.cd.pangu16.com/#/login',
  baseURL: '/passport-server/',
  //baseURL: 'http://tangfeifei.cd.pangu16.com:16000/passport-server/',
  //baseURL: 'http://localhost:16000/passport-server/',
  APPDownloadURL: 'http://update-dev.cd.pangu16.com/wechat/',
  passportServerURL: 'http://dev.cd.pangu16.com/passport-server/',
  contentServerURL: 'http://dev.cd.pangu16.com/content-server/',
  wechatURL: 'http://dev.cd.pangu16.com/wechat/',
  reportServerURL: 'http://dev.cd.pangu16.com/report-server/',
  domain: 'http://dev.cd.pangu16.com/',
  ticketIdKey: 'ticketId_passport', // 当前登录凭证缓存名，避免个项目冲突每个项目一个唯一命名
  cacheKey: 'cache_passport', //当前路由缓存key名，避免个项目冲突每个项目一个唯一命
  pageOpenedListKey: 'pageOpenedListKey_passport', //当前路由缓存key名，避免个项目冲突每个项目一个唯一命
  version: '1',
  secretKey: 'Pangu16@Password',
}
const prodConf = {
  ssoLoginUrl: '/passport/#/login',
  baseURL: '/passport-server/',
  ticketIdKey: 'ticketId_passport', //当前登录凭证缓存名，避免个项目冲突每个项目一个唯一命名
  cacheKey: 'cache_passport', //当前路由缓存key名，避免个项目冲突每个项目一个唯一命
  pageOpenedListKey: 'pageOpenedListKey_passport', //当前路由缓存key名，避免个项目冲突每个项目一个唯一命
  version: '1',
  checkDeviceUrl: '/passport/#/checkDevice',
  helpUrl: '/help/',
  passportServerURL: '/passport-server/',
  contentServerURL: '/content-server/',
  openServerURL: '/open-server/',
  wechatURL: '/wechat/',
  marketURL: '/market/#/',
  moneyURL: '/money/#/',
  domain: '',
  APPDownloadURL: 'http://update-test-a.cd.pangu16.com/wechat/', //app下载页面地址
  findBiUrl: '/report/',
  strategyUrl: 'rest/ezcomp/index/getPolicySetting',
  reportServerURL: '/report-server/',
  secretKey: 'Pangu16@Password',
}

const conf = process.env.NODE_ENV === 'development' ? devConf : prodConf

export default conf
